module.exports = __webpack_public_path__ + "img/no_games.10e9f25e.png";